<template>
    <vs-chip v-if="params.value" class="ag-grid-cell-chip" :color="chipColor(params.value)">
      <span v-if="params.value.length < 55">{{ params.value }}</span>
      <span v-else>{{ params.value.substring(0,55) }}...</span>
    </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  computed: {
    chipColor () {
      return (value) => {
        if (value.startsWith("APV")) return "#7DA7BC"
        if (value.startsWith("AVIZ")) return '#de6f9c'
        if (value && value != 'N/A') return 'warning'
        else if (value == 'N/A') return ''
        /*else if (value === '5/5') return 'success'
        else if (value === '4/5') return 'success'
        else if (value === '3/5') return 'warning'
        else if (value === '2/5') return 'warning'
        else if (value === '1/5') return 'danger'
        else if (value === '0/5') return 'danger'
        else if (value === 'Reception') return 'success'
        else if (value === 'Sale') return 'danger'
        else if (value === 'Transformation') return '#7DA7BC'
        else if (value === 'Inventory') return 'warning'*/
        else return '' 
      }
    }
  }
}
</script>
